import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { 
  FileText, 
  Search, 
  Settings, 
  CreditCard, 
  MessageCircle, 
  Shield,
  Home,
  Users,
  Bell,
  HelpCircle,
  ClipboardList
} from "lucide-react";

interface Category {
  name: string;
  count: number;
}

interface HelpCategoryGridProps {
  categories: Category[];
  onSelectCategory: (category: string) => void;
}

const categoryIcons: Record<string, any> = {
  "Getting Started": Home,
  "Account Management": Users,
  "Property Listings": FileText,
  "Property Management": Settings,
  "Searching Properties": Search,
  "Search & Discovery": Search,
  "Saved Properties": FileText,
  "Subscription & Billing": CreditCard,
  "Payments & Billing": CreditCard,
  "Notifications": Bell,
  "Communication": MessageCircle,
  "Seller Interaction": MessageCircle,
  "Security & Privacy": Shield,
  "Troubleshooting": HelpCircle,
  "Mobile App": Home,
  "Deal Tracker": ClipboardList,
};

const HelpCategoryGrid = ({ categories, onSelectCategory }: HelpCategoryGridProps) => {
  const getIcon = (categoryName: string) => {
    const Icon = categoryIcons[categoryName] || FileText;
    return Icon;
  };

  return (
    <div>
      <h2 className="text-2xl font-bold text-foreground mb-6">Browse by Category</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {categories.map((category) => {
          const Icon = getIcon(category.name);
          return (
            <Card
              key={category.name}
              className="bg-card border-border hover:border-primary/50 transition-colors cursor-pointer"
              onClick={() => onSelectCategory(category.name)}
            >
              <CardContent className="p-6">
                <div className="flex items-start justify-between mb-3">
                  <div className="h-10 w-10 rounded-lg bg-primary/10 flex items-center justify-center">
                    <Icon className="h-5 w-5 text-primary" />
                  </div>
                  <Badge variant="secondary">{category.count}</Badge>
                </div>
                <h3 className="text-base font-semibold text-foreground">
                  {category.name}
                </h3>
              </CardContent>
            </Card>
          );
        })}
      </div>
    </div>
  );
};

export default HelpCategoryGrid;
